var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"click":_vm.updateLocation}},[_c('v-icon',{attrs:{"title":_vm.title,"color":"primary","disabled":!_vm.location,"dense":""}},[_vm._v("mdi-crosshairs-gps")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }